import React, { createContext, useContext, type ReactNode } from 'react';
import { useStore } from '@/store/useStore';

interface AppContextProps {
    user: any;
    wallet: any;
    xp: number;
    subStatus: string;
    fetchUser: (telegram_id: number) => Promise<void>;
    refreshBalance: () => void;
}

const AppContext = createContext<AppContextProps | undefined>(undefined);

export const AppProvider = ({ children }: { children: ReactNode }) => {
    const { user, wallet, fetchUser } = useStore();

    // Derived V3 state
    const xp = (user as any)?.total_xp || 0;
    const subStatus = (user as any)?.subscription_tier || 'Free';

    const refreshBalance = () => {
        if (user?.telegram_id) {
            fetchUser(user.telegram_id);
        }
    };

    return (
        <AppContext.Provider value={{ user, wallet, xp, subStatus, fetchUser, refreshBalance }}>
            {children}
        </AppContext.Provider>
    );
};

export const useAppContext = () => {
    const context = useContext(AppContext);
    if (context === undefined) {
        throw new Error('useAppContext must be used within an AppProvider');
    }
    return context;
};
